import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateKit($id: String!, $data: updateKitInput!) {
    updateKit(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateKitRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateKitInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'kit/update_kit',
  async (
  params: {id: String;data: TYPES.UpdateKitInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateKit;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateKitSlice = createSlice({
  name: 'update_kit',
  initialState: initialState,
  reducers: {
    updateKitClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateKitRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateKitRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateKitRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateKitClear } = updateKitSlice.actions;

export const updateKit = createSelector(
  (state: RootState) => state.kit.updateKit.result,
  (state: RootState) => state.kit.updateKit.error,
  (state: RootState) => state.kit.updateKit.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateKitSlice.reducer;